import type { LoyaltyOffersHubHeroCarouselItem } from './types'

export function getLoyaltyOffersHubHeroCarouselItemId(item: LoyaltyOffersHubHeroCarouselItem): string {
  return `${item.imageId}-${item.ctaUrl}-${item.title}`
}
